// lib/repo-paths.mjs のブラウザ代替。物理ディレクトリの代わりに VFS 上の仮想ルートを使う。
// レイアウトは Node 版と 1:1（TOOLS_DIR=/vfs/tools, NEWGAMES_DIR=/vfs/newgames, ...）。
import path from './path.mjs';
import { vfs } from '../vfs.mjs';

export const REPO_ROOT = '/vfs';
export const TOOLS_DIR = '/vfs/tools';
export const NEWGAMES_DIR = '/vfs/newgames';
// ブラウザでは sevenfold の共有マスタを /_runtime/ からこのVFS領域へ常駐させる。
// validate-i18n のja/en基準比較も同じ正本を参照する。
export const SEVENFOLD_DIR = '/vfs/_runtime_defaults';
export const CONFIG_DIR = '/vfs/tools/config';
export const DATA_DIR = '/vfs/tools/data';
export const LOGS_DIR = '/vfs/tools/logs';

export function assertRepoRoot() {
    return REPO_ROOT;
}

/** base 配下に封じ込めた絶対パス。`../` 等での脱出はエラー（Node 版と同じ契約）。 */
export function containedPath(base, ...segments) {
    const resolved = path.resolve(base, ...segments);
    const normalizedBase = path.resolve(base);
    if (resolved !== normalizedBase && !resolved.startsWith(normalizedBase + '/')) {
        throw new Error(`パスがベースディレクトリ外を指しています: ${segments.join('/')}`);
    }
    return resolved;
}

export function repoPath(...segments) {
    return containedPath(REPO_ROOT, ...segments);
}

export function gameDirOf(gameId) {
    if (!/^[a-z][a-z0-9_-]*$/.test(gameId)) {
        throw new Error(`不正な gameId です: ${gameId}`);
    }
    return containedPath(NEWGAMES_DIR, gameId);
}

let protectedConfigCache = null;
function protectedConfig() {
    if (!protectedConfigCache) {
        try {
            protectedConfigCache = JSON.parse(vfs.read(path.join(CONFIG_DIR, 'protected-files.json')));
        } catch {
            protectedConfigCache = { basenames: [], repoRelativePaths: [], protectedDirsRepoRelative: [], importOnlyRejectBasenames: [] };
        }
    }
    return protectedConfigCache;
}

export function isProtectedPath(absPath, context = 'any') {
    const cfg = protectedConfig();
    const base = path.basename(absPath);
    if ((cfg.basenames ?? []).includes(base)) return true;
    if (context === 'import' && (cfg.importOnlyRejectBasenames ?? []).includes(base)) return true;
    const rel = path.relative(REPO_ROOT, absPath);
    if ((cfg.repoRelativePaths ?? []).includes(rel)) return true;
    for (const dir of cfg.protectedDirsRepoRelative ?? []) {
        if (rel === dir || rel.startsWith(dir + '/')) return true;
    }
    return false;
}

export function assertNotProtected(absPath, context = 'any') {
    if (isProtectedPath(absPath, context)) {
        throw new Error(`保護ファイルのため操作を拒否しました: ${path.relative(REPO_ROOT, absPath)}`);
    }
}
